import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ExcelDownloadService } from '../../../app/shared/services/excel-download.service';
import { SharedService } from '../../shared/services/shared.service';
import { MakeAPaymentService } from '../make-a-payment.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentConfirmationComponent implements OnInit, OnDestroy {
  creditPaymentList: any = [];
  invoicePaymentList: any = [];
  creditConfirmationList: any = [];
  creditInvoice: string;
  currentDate = new Date();
  userData: any;
  personName: string;
  compNameAdBanner1 = 'InvoiceBannerComponent';
  invoiceConfirmList: any = [];
  selectedCardDetails: any;
  dispCardNumber: any;
  disabled: boolean;
  isPDF: boolean;
  errorMsg: string;
  authErrorMsg: string;
  errorMsg1: string;
  asmEmailDetails: any;
  isAsmEnabled: any;
  userSubscription: any;
  csAgentAuthSubscription: any;

  constructor(
    private readonly datePipe: DatePipe,
    private readonly sharedService: SharedService,
    private readonly router: Router,
    private readonly user: UserAccountFacade,
    public excelService: ExcelDownloadService,
    private readonly cdr: ChangeDetectorRef,
    private readonly makeAPayment: MakeAPaymentService,
    private readonly csAgentAuthService: CsAgentAuthService
  ) {}

  handleValidList(List, confirmationList, successMsg, errMsg): void {
    this.creditPaymentList = List;
    this.creditConfirmationList = confirmationList;
    this.creditInvoice = '';
    if (this.creditConfirmationList !== null) {
      const data =
        this.creditConfirmationList.invoiceCreditPayResponseList.filter(
          (item) => item.type === 'E'
        );
      if (data.length > 0) {
        this.errorMsg = this.creditMessage();
        this.errorMsg1 = errMsg;
      } else {
        this.errorMsg = successMsg;
        this.errorMsg1 = '';
      }
    }
  }

  ngOnInit(): void {
    const successMsg = 'We have processed your request.';
    this.userSubscription = this.user.get().subscribe((res) => {
      if (res) {
        this.userData = res;
      }
      this.cdr.detectChanges();
    });
    this.personName = this.sharedService.getSessionStorage('creditPersonName');
    const confirmationList =
      this.sharedService.getSessionStorage('creditConfirmation');
    const errMsg =
      'Please try again later or call us at 0770618663/07705098290509829.';
    const List = this.sharedService.getSessionStorage('creditData');
    if (List !== null) {
      this.handleValidList(List, confirmationList, successMsg, errMsg);
    } else {
      const FOUR = 4;
      this.creditInvoice = 'invoiceTable';
      this.selectedCardDetails =
        this.sharedService.getSessionStorage('selectedCard');
      this.dispCardNumber =
        this.selectedCardDetails?.displayCardNumber.split('-');
      if (!!this.dispCardNumber) {
        this.dispCardNumber.cardNumber = this.dispCardNumber[FOUR];
      }
      this.invoicePaymentList =
        this.sharedService.getSessionStorage('invoicesData');
      this.invoiceConfirmList = this.sharedService.getSessionStorage(
        'paymentConfirmation'
      );
      if (this.invoiceConfirmList !== null) {
        this.invoiceConfirmList?.openinvoiceItems.forEach((element) => {
          element.netBalance = element.netBalance.toString();
          element.payAmount = element.payAmount.toString();
        });
        if (this.invoiceConfirmList?.authMessage === undefined) {
          if (this.invoiceConfirmList?.message === 'Approved') {
            this.errorMsg = successMsg;
            this.errorMsg1 = '';
          } else {
            this.errorMsg = this.invoiceMessage();
            this.errorMsg1 = errMsg;
          }
        } else {
          this.authErrorMsg = 'Credit authorization failed';
          this.errorMsg = this.invoiceMessage();
          this.errorMsg1 = errMsg;
        }
      }
    }
    this.csAgentAuthSubscription = this.csAgentAuthService
      .isCustomerEmulated()
      .subscribe((res) => {
        this.isAsmEnabled = res;
        if (this.isAsmEnabled) {
          this.asmEmailDetails = this.sharedService.getLocalStorage('asmEmail');
          this.personName =
            this.sharedService.getLocalStorage('creditPersonName');
          const confirmationListAsm =
            this.sharedService.getLocalStorage('creditConfirmation');
          const ListAsm = this.sharedService.getLocalStorage('creditData');
          if (ListAsm !== null) {
            this.creditPaymentList = ListAsm;
            this.creditConfirmationList = confirmationListAsm;
            this.creditInvoice = '';
            const data =
              this.creditConfirmationList.invoiceCreditPayResponseList.filter(
                (item) => item.type === 'E'
              );
            if (data.length > 0) {
              this.errorMsg = this.creditMessage();
              this.errorMsg1 = errMsg;
            } else {
              this.errorMsg = successMsg;
              this.errorMsg1 = '';
            }
          } else {
            const FOUR = 4;
            this.creditInvoice = 'invoiceTable';
            this.selectedCardDetails =
              this.sharedService.getLocalStorage('selectedCard');
            this.dispCardNumber =
              this.selectedCardDetails?.displayCardNumber.split('-');
            if (
              this.dispCardNumber !== undefined &&
              this.dispCardNumber !== null
            ) {
              this.dispCardNumber.cardNumber = this.dispCardNumber[FOUR];
            }
            this.invoicePaymentList =
              this.sharedService.getLocalStorage('invoicesData');
            this.invoiceConfirmList = this.sharedService.getLocalStorage(
              'paymentConfirmation'
            );
            this.invoiceConfirmList?.openinvoiceItems.forEach((element) => {
              element.netBalance = element.netBalance.toString();
              element.payAmount = element.payAmount.toString();
            });
            this.handleInvoiceConfirmListAuthMessage(successMsg, errMsg);
          }
        }
        this.cdr.detectChanges();
      });
  }

  handleInvoiceConfirmListAuthMessage(successMsg, errMsg): void {
    if (this.invoiceConfirmList?.authMessage === undefined) {
      if (this.invoiceConfirmList?.message === 'Approved') {
        this.errorMsg = successMsg;
        this.errorMsg1 = '';
      } else {
        this.errorMsg = this.invoiceMessage();
        this.errorMsg1 = errMsg;
      }
    } else {
      this.authErrorMsg = 'Credit authorization failed';
      this.errorMsg = this.invoiceMessage();
      this.errorMsg1 = errMsg;
    }
  }

  creditMessage() {
    let msg = 'Credit ';
    const totalSelectedData = [];
    this.creditConfirmationList.invoiceCreditPayResponseList.forEach(
      (element) => {
        let selectedData;
        if (element.type === 'E') {
          if (element.credDocType === 'DZ') {
            selectedData = element.credDohdrTxt;
          } else {
            selectedData = element.credRefDocnum;
          }
          totalSelectedData.push(selectedData);
        }
      }
    );
    totalSelectedData.forEach((element, index) => {
      msg += `#${element}`;
      if (totalSelectedData.length - 1 !== index) {
        msg += ', ';
      }
    });
    msg += ' cannot be processed at this time.';
    return msg;
  }
  invoiceMessage() {
    let msg = 'Invoice ';
    const totalSelectedData = [];
    this.invoiceConfirmList.openinvoiceItems.forEach((element) => {
      if (element.message !== 'Approved') {
        totalSelectedData.push(element.invoiceNumber);
      }
    });
    totalSelectedData.forEach((element, index) => {
      msg += `#${element}`;
      if (totalSelectedData.length - 1 !== index) {
        msg += ', ';
      }
    });
    msg += ' cannot be processed at this time.';
    return msg;
  }
  excelDownload() {
    const excelArray = [];
    let excelName;
    if (this.creditInvoice === 'invoiceTable') {
      excelName = 'InvoiceConfirmation';
      const FOUR = 4;
      this.invoiceConfirmList?.openinvoiceItems.forEach((element) => {
        const obj = {
          Status: this.invoiceConfirmList.message,
          'Invoice #': element.invoiceNumber,
          'Due date': element.dueDate,
          'Net invoice balance': element.netBalance,
          'Payment amount': element.payAmount,
          'Payment method': `${element.cardType},${this.dispCardNumber[FOUR]}`,
          'Payment date': this.datePipe.transform(
            this.currentDate,
            'dd/MM/yyyy'
          ),
        };
        excelArray.push(obj);
      });
    } else {
      excelName = 'CreditConfirmation';
      this.creditConfirmationList?.invoiceCreditPayResponseList.forEach(
        (element) => {
          let credit;
          if (element.credDocType !== 'DZ') {
            credit = element.credRefDocnum;
          } else {
            credit = element.credDohdrTxt;
          }
          let invoice;
          if (element.invDocType !== 'DZ') {
            invoice = element.invRefDocnum;
          } else {
            invoice = element.invDohdrTxt;
          }
          const obj = {
            Status: element.msg,
            'Credit #': credit,
            'Apply to invoice#': invoice,
            'Credit applied': element.invAmt,
            'New credit balance': element.credAmt,
            'New invoice balance': element.invBal,
            'Credit applied date': this.datePipe.transform(
              this.currentDate,
              'dd/MM/yyyy'
            ),
          };
          excelArray.push(obj);
        }
      );
    }
    this.excelService.exportAsExcelFile(excelArray, excelName, true);
  }
  return(): void {
    this.router.navigate(['/my-account/invoices']);
  }

  async generatePDF(): Promise<void> {
    this.isPDF = true;
    this.cdr.detectChanges();

    // SSR guard
    if (typeof window === 'undefined') {
      this.isPDF = false;
      return;
    }

    const isInvoice = this.creditInvoice === 'invoiceTable';

    const config = {
      invoiceTable: {
        elemId: 'invoice-table',
        filename: 'PaymentConfirmation.pdf',
      },
      creditTable: {
        elemId: 'credits-table',
        filename: 'CreditConfirmation.pdf',
      },
    } as const;

    const currentConfig = isInvoice ? config.invoiceTable : config.creditTable;

    const element = document.getElementById(currentConfig.elemId);
    if (!element) {
      this.isPDF = false;
      this.cdr.detectChanges();
      return;
    }

    // Clone DOM safely
    const domClone = element.cloneNode(true) as HTMLElement;

    // Build PDF section
    const section = document.createElement('section');
    section.setAttribute('id', 'pdf-invoices');

    const line = document.getElementById('line-sanofi');
    if (line) {
      section.appendChild(line);
    }

    section.appendChild(domClone);

    const dummy = document.getElementById('pdf-dummy');
    if (!dummy) {
      this.isPDF = false;
      this.cdr.detectChanges();
      return;
    }

    dummy.appendChild(section);

    const updatedElem = dummy;

    // Wait for images to load
    const images = Array.from(updatedElem.querySelectorAll('img'));
    await Promise.all(
      images.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) {
              resolve(true);
            } else {
              img.onload = () => resolve(true);
              img.onerror = () => resolve(false);
            }
          })
      )
    );

    const options = {
      margin: 10,
      filename: currentConfig.filename,
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
    } as any;

    // Dynamic import (SSR-safe)
    const html2pdfModule = await import('html2pdf.js');

    await html2pdfModule.default().from(updatedElem).set(options).save();

    // Cleanup
    section.remove();

    this.isPDF = false;
    this.cdr.detectChanges();
  }

  invoicePdf(invoiceNo): void {
    this.makeAPayment.downloadPdf(invoiceNo);
  }

  creditPdf(creditNo): void {
    this.makeAPayment.downloadPdf(creditNo);
  }
  print() {
    window?.print();
  }
  ngOnDestroy() {
    this.userSubscription?.unsubscribe();
    this.csAgentAuthSubscription?.unsubscribe();
  }
}
